import React from 'react';
import { Image, View } from 'react-native';

import { ThemedText } from '@/components/themed-text';

export function getInitials(name: string | undefined | null): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
}

export function getFirstName(name: string | undefined | null): string {
  return (name ?? '').trim().split(/\s+/)[0] || 'Profissional';
}

/** "Ana", "Ana e Pedro", "Ana, Pedro e Bia". */
export function joinFirstNames(names: string[]): string {
  const first = names.map(getFirstName);
  if (first.length <= 1) return first.join('');
  return `${first.slice(0, -1).join(', ')} e ${first[first.length - 1]}`;
}

/**
 * Foto do profissional, ou as iniciais sobre a cor dele na equipe. A cor é a
 * mesma da coluna na agenda da equipe, então o avatar já identifica a pessoa.
 */
export function MemberAvatar({
  name,
  image,
  color,
  size = 28,
  initials,
}: {
  name: string;
  image?: string | null;
  color?: string | null;
  size?: number;
  /** Sobrescreve as iniciais — o negócio usa só a primeira letra do nome. */
  initials?: string;
}) {
  if (image) {
    return (
      <Image
        source={{ uri: image }}
        accessibilityIgnoresInvertColors
        aria-hidden
        style={{ width: size, height: size, borderRadius: size / 2 }}
      />
    );
  }
  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor: color ?? '#FD5001',
      }}
      className="items-center justify-center"
    >
      <ThemedText style={{ fontSize: size * 0.4 }} className="font-semibold text-white">
        {initials ?? getInitials(name)}
      </ThemedText>
    </View>
  );
}
